module.exports = __webpack_public_path__ + "static/feature2-6c9777ed203c2c1ed0e5ddd3d7d40635.jpg";